import { createAction } from '@reduxjs/toolkit';

import { UISliceState } from './types';

export const setEditorLoading = createAction<Partial<UISliceState['loading']>>(
  'editor-ui/setLoading',
);
export const toggleGrid = createAction('editor-ui/toggleGrid');
export const toggleAnnotations = createAction('editor-ui/toggleAnnotations');
export const setEditingPropertyKey = createAction<{
  propertyKey: null | string;
}>('editor-ui/setPropertyKey');
